export const TYPES = {
	RAW_TYPE: 'rawType',
	EXTRA_RAW_TYPE: 'extraRawType',
	RAW_VIDEO_TYPE: 'rawVideoType',
	EDITED_IMAGE_TYPE: 'editedImageType',
	EDITED_VIDEO_TYPE: 'editedVideoType'
};
